import { useState, useRef } from "react";
import "@/App.css";

// Components
import FloatingPetals from "./components/FloatingPetals";
import MusicPlayer from "./components/MusicPlayer";
import IntroScreen from "./components/IntroScreen";
import HeroSection from "./components/HeroSection";
import CountingDown from "./components/CountingDown";
import CoupleSection from "./components/CoupleSection";
import Timeline from "./components/Timeline";
import LocationCard from "./components/LocationCard";
import Gallery from "./components/Gallery";
// import RSVPForm from "./components/Rsvp";
import Footer from "./components/Footer";

function App() {
  const [isIntroHidden, setIsIntroHidden] = useState(false);
  const [isMusicAutoPlay, setIsMusicAutoPlay] = useState(false);
  const musicPlayerRef = useRef(null);

  const handleOpenInvitation = () => {
    setIsIntroHidden(true);
    setIsMusicAutoPlay(true);

    // Try to play music when user clicks open
    if (musicPlayerRef.current) {
      musicPlayerRef.current.play();
    }
  };

  return (
    <div className="App min-h-screen bg-[#FCFAF2]" data-testid="app-container">
      {/* Floating Petals Background */}
      <FloatingPetals />

      {/* Music Player - Always visible */}
      <MusicPlayer ref={musicPlayerRef} autoPlay={isMusicAutoPlay} />

      {/* Intro Screen Overlay */}
      <IntroScreen onOpen={handleOpenInvitation} isHidden={isIntroHidden} />

      {/* Main Content */}
      <main
        className={`transition-opacity duration-1000 ${
          isIntroHidden ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        data-testid="main-content"
      >
        <HeroSection />
        <CountingDown />
        <CoupleSection />
        <Timeline />
        <LocationCard />
        <Gallery />
        {/* <RSVPForm invitationId="8217a161-1dcc-4302-b61e-e9c3c46c8cb8" /> */}
        <Footer />
      </main>
    </div>
  );
}

export default App;
